import React from 'react';
import { Info } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useExpertNdaBannerViewModel } from './viewModel';

/** NDA reminder shown at the top of the expert area while the agreement is unsigned.
 *  `className` lets a layout that removes its own gutters (the phone message
 *  board) give the banner back some breathing room. */
export function ExpertNdaBanner({ className }: { className?: string } = {}) {
  const { showNdaBanner } = useExpertNdaBannerViewModel();

  if (!showNdaBanner) return null;

  return (
    <div
      role="status"
      className={[
        'mb-4 flex flex-wrap items-center gap-2 rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-blue-900',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Info className="h-[18px] w-[18px] shrink-0 text-blue-700" aria-hidden="true" />
      <p className="min-w-0 flex-1 text-sm">
        <span className="font-semibold">NDA Required</span>
        <span className="ml-2">
          You must review and accept the Non-Disclosure Agreement before you can be assigned to client projects.
        </span>
      </p>
      <Link
        to="/expert/settings/nda-agreement"
        className="shrink-0 rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-white hover:bg-primary-hover"
      >
        Review NDA
      </Link>
    </div>
  );
}
